import React from 'react';
import { Users, Send, MessageSquare, MoreHorizontal } from 'lucide-react';
import { Button } from '@vaiu/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@vaiu/ui/dropdown-menu';
import { Contact } from '@/services/platformApi';
import ContactCard from './ContactCard';

interface ContactListProps {
  contacts: Contact[];
  onContactSelect: (contact: Contact) => void;
  onSendMoney: (contact: Contact) => void;
  emptyMessage: string;
  merchantProfilesCache?: Map<string, any>;
  totalsByCurrency?: Map<string, Record<string, { sent: number; received: number }>>;
  userCurrency?: string;
}

const ContactList: React.FC<ContactListProps> = ({
  contacts,
  onContactSelect,
  onSendMoney,
  emptyMessage,
  merchantProfilesCache,
  totalsByCurrency,
  userCurrency
}) => {
  if (contacts.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
          <Users className="w-6 h-6 text-muted-foreground" />
        </div>
        <h3 className="text-lg font-medium mb-2">No contacts found</h3>
        <p className="text-muted-foreground">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="divide-y">
      {contacts.map((contact, index) => (
        <ContactCard
          key={contact.id}
          contact={contact}
          onClick={() => onContactSelect(contact)}
          onSendMoney={() => onSendMoney(contact)}
          isLast={index === contacts.length - 1}
          merchantProfile={contact.relationship === 'business' && contact.merchantId && merchantProfilesCache?.get(contact.merchantId)}
          totalsByCurrency={totalsByCurrency?.get(contact.id)}
          userCurrency={userCurrency}
        />
      ))}
    </div>
  );
};

export default ContactList; 